export default __webpack_public_path__ + "static/img-kortical-timeline--mobile-5de3ba567c9f5abe8d99d3026d1e4193.png";